import * as firebase from 'firebase/app';
import 'firebase/auth';

export default firebase.auth;
